<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "TV Shows",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
         return {
            loading: true,
            title: "TV Shows",
            items: [
               {
                  text: "TV Shows",
                  active: true,
               },                   
            ],

            max_date: today_str,
            from_date: today_str,
            to_date: today_str,

            type : "",
            tvshows: [],
            tvshow: {
               id: "",
               type: "",
               clinic_id : "",
               pharmacy_id: "",
               lab_id:"",
               title: "",
               video: "",
               for: 1,
               expiry: "",
               agency: "",
               doctor_id: "",
               slot: "",
               duration: "",
            },
            clinic_lists: [],
            doctor_lists: [],
            pharmacy_lists: [],
            lab_lists: [],
            clinics: [],
            doctors: [],
            pharmacies: [],
            labs: [],
            video: "",
            users:"",

            agencies: [],
            clinic_tv: [],
            pharmacy_tv: [],
            lab_tv: [],
            showTv: [],
            tv_id: "",
            doctors_tv: [],

            modal_title: "Add TV Show",
            button_title: "Save",
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,         
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},
            doctor_keyword:"",
            delete: "",
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchTVShows();
         this.fetchClinics(1);
         this.fetchDoctors();
         this.fetchAgencies();
         this.fetchPharmacies();
         this.fetchLabs();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         fetchTVShows(page_url = null) {

            this.getToken();
            let url = "api/admin/get_tv_show?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.tvshows = responseData.tv_shows.data;
                  
                  this.pagination = responseData.tv_shows.links;
                  this.from = responseData.tv_shows.from;
                  this.to = responseData.tv_shows.to;
                  this.total = responseData.tv_shows.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchClinics(type) {
            let url = "api/admin/tv_show/getTvClinics?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.clinic_lists = responseData.clinics;
               })
               .catch((err) => console.log(err));
         },
         fetchDoctors() {
               let url = "api/admin/tv_show/getTvDoctors";         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.doctor_lists = responseData.doctors;
                  })
                  .catch((err) => console.log(err));
         },

         fetchPharmacies() {
            let url = "api/admin/pharmacy/getTvPharmacies";        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.pharmacy_lists = responseData.pharmacies;
               })
               .catch((err) => console.log(err));
         },

         fetchLabs() {
            let url = "api/admin/lab/getTvLabs";        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.lab_lists = responseData.labs;
               })
               .catch((err) => console.log(err));
         },

         fetchAgencies() {
               let url = "api/admin/getAgencies";         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.agencies = responseData.agencies;
                  })
                  .catch((err) => console.log(err));
         },

         fetchClinicTv() {
               let url = "api/admin/clinicTV?clinic_id=" + this.tvshow.clinic_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.clinic_tv = responseData.clinic_tv;
                  })
                  .catch((err) => console.log(err));
         },

         fetchDoctorTv() {
               let url = "api/admin/doctorTV?doctor_id=" + this.tvshow.doctor_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.doctors_tv = responseData.doctors_tv;
                  })
                  .catch((err) => console.log(err));
         },

          fetchPharmacyTv() {
               let url = "api/admin/pharmacyTV?pharmacy_id=" + this.tvshow.pharmacy_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.pharmacy_tv = responseData.pharmacy_tv;
                  })
                  .catch((err) => console.log(err));
         },

          fetchLabTv() {
               let url = "api/admin/labTV?lab_id=" + this.tvshow.lab_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.lab_tv = responseData.lab_tv;
                  })
                  .catch((err) => console.log(err));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         setFile(e) {
            this.video = e.target.files[0];
         },

         editTVShow(tvshow) {  
            this.fetchClinics(2);        
            this.modal_title = "Edit TV Show";
            this.button_title = "Update";
            this.tvshow.id = tvshow.id;
            this.tvshow.type = tvshow.type;
            this.tvshow.clinic_id = tvshow.clinic_id; 
            this.tvshow.title = tvshow.title;
            this.tvshow.video = tvshow.video;          
            this.edit = true;
            this.showModal("tvshow-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add TV Show";
            this.button_title = "Add";
            this.tvshow.for = 1;
            this.tvshow.id = "";
            this.tvshow.type = "";
            this.tvshow.clinic_id = "";    
            this.tvshow.title = "";
            this.tvshow.video = "";
            this.tvshow.expiry = "";
            this.tvshow.slot = "";
            this.tvshow.agency = "";
            this.tvshow.clinic_id = "";
            this.tvshow.doctor_id = "";
            this.tvshow.pharmacy_id = "";
            this.tvshow.lab_id = "";
            this.tvshow.duration = "";
            this.edit = false;

            this.video = "";

            this.errors = {};
            this.clinics = [];
            this.doctors = [];
            this.pharmacies = [];
            this.labs = [];
            this.showTv = [];
            this.clinic_tv = [];
            this.doctors_tv = [];
            this.pharmacy_tv = [];
            this.lab_tv = [];
            this.tv_id = "";
         },

         addTVShow() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/addTvShow";
               this.active_page_url = null;

            } else {
               url = "api/admin/tv_show/edit";
               formData.append("tv_show_id", this.tvshow.id); 
            }         

            formData.append("title", this.tvshow.title); 
            formData.append("type", this.tvshow.type); 
            formData.append("duration", this.tvshow.duration); 
            formData.append("slot", this.tvshow.slot); 
            formData.append("agency_id", this.tvshow.agency); 
            formData.append("validity", this.tvshow.expiry);
         
            if(this.tvshow.type == 2) {
               // formData.append('users', JSON.stringify(this.clinics));
               if (this.clinics.length) {
                  formData.append('users', JSON.stringify(this.clinics));
               } else {
                  // Force it to be considered "missing"
                  formData.append('users', '');
               }
            } if(this.tvshow.type == 4){
               // formData.append('users', JSON.stringify(this.doctors));
                if (this.doctors.length) {
                  formData.append('users', JSON.stringify(this.doctors));
               } else {
                  // Force it to be considered "missing"
                  formData.append('users', '');
               }
            }
            if(this.tvshow.type == 8){
                if (this.pharmacies.length) {
                  formData.append('users', JSON.stringify(this.pharmacies));
               } else {
                  formData.append('users', '');
               }
            }
            if(this.tvshow.type == 11){
                if (this.labs.length) {
                  formData.append('users', JSON.stringify(this.labs));
               } else {
                  formData.append('users', '');
               }
            }
            if(this.tvshow.type == 5) {
                if(this.tvshow.clinic_id){
                  formData.append('clinic_id', JSON.stringify(this.tvshow.clinic_id));
                }
               // formData.append('tv_id', JSON.stringify(this.showTv));
            } 
            if(this.tvshow.type == 6){
               if(this.tvshow.doctor_id){
                  formData.append('doctor_id', JSON.stringify(this.tvshow.doctor_id));
               }
               // formData.append('tv_id', JSON.stringify(this.showTv));
              
            }
            if(this.tvshow.type == 9){
               if(this.tvshow.pharmacy_id){
                  formData.append('pharmacy_id', JSON.stringify(this.tvshow.pharmacy_id));
               }
             
            }
            if(this.tvshow.type == 12){
               if(this.tvshow.lab_id){
                  formData.append('lab_id', JSON.stringify(this.tvshow.lab_id));
               }
             
            }
            
            if(this.tvshow.type == 5 || this.tvshow.type == 6 || this.tvshow.type == 9 || this.tvshow.type == 12) {
               if (this.showTv.length) {
                  formData.append('tv_id', JSON.stringify(this.showTv));
               } else {
                  // Force it to be considered "missing"
                  formData.append('tv_id', '');
               }
            }


            if(this.video) {
               formData.append("video", this.video); 
            } else {
               formData.append("video", ""); 
            }

            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('tvshow-modal');
                  this.fetchTVShows(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                         this.loading = false;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            // .finally(() => (this.loading = false));
         },

         deleteTVShow(tvshow_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this TV show?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                  console.log(this.token);
                  let formData = new FormData();
                  formData.append("tv_show_id", tvshow_id); 

                  // var formData = JSON.stringify({
                  //    "tv_show_id": tvshow_id
                  // });

                  let url = "api/admin/tv_show/delete";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchTVShows(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         addDoctor() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let doctor_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.doctors.some(function(doctor) {
               return index === doctor.id;
            });

            if(!exists) {
               this.doctors.push({ id: index , title: text , doctor_id: doctor_id});
            }
            console.log(this.doctors);
            this.doctor = '';
         },
         removeShow(index) {
            this.doctors.splice(index, 1);
         }, 

         addClinic() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let clinic_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.clinics.some(function(clinic) {
               return index === clinic.id;
            });

            if(!exists) {
               this.clinics.push({ id: index , title: text ,clinic_id: clinic_id});
            }
            this.clinic = '';
         },
         removeClinic(index) {
            this.clinics.splice(index, 1);
         },

         addPharmacy() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let pharmacy_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.pharmacies.some(function(pharmacy) {
               return index === pharmacy.id;
            });

            if(!exists) {
               this.pharmacies.push({ id: index , title: text ,pharmacy_id: pharmacy_id});
            }
            this.pharmacy = '';
         },
         removePharmacy(index) {
            this.pharmacies.splice(index, 1);
         },

         addLab() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let lab_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.labs.some(function(lab) {
               return index === lab.id;
            });

            if(!exists) {
               this.labs.push({ id: index , title: text ,lab_id: lab_id});
            }
            this.lab = '';
         },
         removeLab(index) {
            this.labs.splice(index, 1);
         },

         addTv() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let tvId = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.showTv.some(function(tv) {
               return index === tv.id;
            });

            if(!exists) {
               this.showTv.push({id: index , title: text, tv_id: tvId});
              }
            this.tv = '';
         },

         removeTv(index) {
            this.showTv.splice(index, 1);
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.tvshow-modal variant="primary" class="float-end">Add TV Show</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchTVShows()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchTVShows()"/>
                           </label>
                        </div>                     
                        <!-- <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option :value="null">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>    -->
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th width="3%">Sl No</th>
                              <th width="10%">Show Name</th>
                              <th width="10%">Agency</th>
                              <th width="5%">For</th>
                              <th width="10%">Clinic</th>
                              <th width="10%">Doctor</th>
                              <th width="10%">Pharmacy</th> 
                              <th width="10%">Lab</th>  
                              <th width="10%">Video</th>
                              <th width="10%">Expired On</th>   
                              <th width="10%">Created On</th>
                              <th width="8%">Options</th>          
                       
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(tvshows.length)">
                           <tr v-for="(tvshow, index) in tvshows" :key="tvshow.id">
                              <td>{{index + from}}</td>
                              <td>{{tvshow.title}}</td>
                              <td>{{tvshow.agency_name}}</td>
                              <td>
                                 <span v-if="tvshow.type==1">All Clinics</span>
                                 <span v-if="tvshow.type==2">Multiple Clinics</span>
                                 <span v-if="tvshow.type==3">All Doctors</span>
                                 <span v-if="tvshow.type==4">Multiple Doctors</span>
                                 <span v-if="tvshow.type==5">Specific Clinic</span>
                                 <span v-if="tvshow.type==6">Specific Doctor</span>
                                 <span v-if="tvshow.type==7">All Pharmacies</span>
                                 <span v-if="tvshow.type==8">Multiple Pharmacies</span>
                                 <span v-if="tvshow.type==9">Specific Pharmacy</span>
                                 <span v-if="tvshow.type==10">All Labs</span>
                                 <span v-if="tvshow.type==11">Multiple Labs</span>
                                 <span v-if="tvshow.type==12">Specific Lab</span>
                              </td>
                              <td>
                                 <span v-if="tvshow.clinic_id">{{tvshow.clinic_name}}</span>
                              </td>
                              <td>
                                 <span v-if="tvshow.doctor_id">{{tvshow.doctor_name}}</span>
                              </td>
                              <td>
                                 <span v-if="tvshow.pharmacy_id">{{tvshow.pharmacy_name}}</span>
                              </td>
                              <td>
                                 <span v-if="tvshow.lab_id">{{tvshow.lab_name}}</span>
                              </td>
                              <td>
                                 <a :href="$image_url + tvshow.video" target="_blank" class="font-size-22"><i class='bx bx-video'></i></a>
                              </td>
                              <td>{{tvshow.validity | formatDate}}</td>
                              <td>{{tvshow.created_at | formatDateTime}}</td>
                              <td>
                                 <router-link :to="{ name: 'tvshows.details', params: {id: tvshow.id} }" class="btn btn-primary btn-sm me-2 mb-2">Details</router-link>
                                 
                                 <button class="btn btn-danger btn-sm mb-2" type="button" @click="deleteTVShow(tvshow.id)">Delete</button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No tv shows found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(tvshows.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchTVShows(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  
                  <b-modal ref="tvshow-modal" id="tvshow-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form  @submit.prevent="addTVShow()">                        
                        <div class="row"> 

                           <b-col md="12" class="form-group">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Agency <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="tvshow.agency" v-bind:class="{ 'is-invalid': Boolean(errors.agency_id) }" >
                                          <option value="">Select</option>
                                          <option :value="agency.id" v-for="agency in agencies" :key="agency.id"> {{agency.name}}</option>
                                       </select> 
                                       <div v-for="(val, index) in errors.agency_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Show for <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="tvshow.for" v-bind:class="{ 'is-invalid': Boolean(errors.for) }">
                                 <!-- <option value="">Select</option> -->
                                 <option value="1">Doctors</option>
                                 <option value="2">Clinics</option>
                                 <option value="3">Pharmacies</option>
                                 <option value="4">Lab</option>
                              </select>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Show Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="tvshow.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>
                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Duration(Sec) <span class="text-danger">*</span></label>
                              <b-form-input v-model="tvshow.duration" v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
                              <div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Slot<span class="text-danger">*</span></label>
                              <b-form-input type="text" v-model="tvshow.slot" v-bind:class="{ 'is-invalid': Boolean(errors.slot) }"></b-form-input>
                              <div v-for="(val, index) in errors.slot" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Expiry Date <span class="text-danger">*</span></label>
                              <b-form-input type="date" v-model="tvshow.expiry" :min="from_date" v-bind:class="{ 'is-invalid': Boolean(errors.validity) }"></b-form-input>
                              <div v-for="(val, index) in errors.validity" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.for==1">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="tvshow.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio   :value="3">All Doctors</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio  :value="4">Multiple Doctors</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio  :value="6">Single Doctor</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                               <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.type==4 && tvshow.for==1">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Doctors <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="this.users" @change="addDoctor()" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                          <option :value="doctor_list.id" v-for="doctor_list in doctor_lists" :key="doctor_list.id"> {{doctor_list.prefix}} {{ doctor_list.name }}</option>
                                       </select> 

                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(doctor, index) in doctors" :key="index">
                                             <p>{{ doctor.title }}<span @click="removeShow(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="tvshow.type==6 && tvshow.for==1">
                              <div class="row">
                                 <div class="form-group col-12"> 
                                    <label class="control-label">Doctors <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="tvshow.doctor_id" @change="fetchDoctorTv()" v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }" >
                                       <option value="">Select</option>
                                       <option :value="doctor_list.id" v-for="doctor_list in doctor_lists" :key="doctor_list.id"> {{doctor_list.prefix}} {{ doctor_list.name }}</option>
                                    </select> 

                                 </div>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="Boolean(doctors_tv.length) && tvshow.for==1">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in doctors_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in showTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.for==2">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="tvshow.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type"  :value="1">All Clinics</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="2">Multiple Clinics</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="5">Single Clinic</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="tvshow.type==2 && tvshow.for==2">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Clinics <span class="text-danger">*</span></label>
                                       
                                       <select class="form-control"  @change="addClinic()" v-model="this.users" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                          <option :value="clinic_list.id" v-for="clinic_list in clinic_lists" :key="clinic_list.id"> {{ clinic_list.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(clinic, index) in clinics" :key="index">
                                             <p>{{ clinic.title }}<span @click="removeClinic(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="tvshow.type==5 && tvshow.for==2">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Clinic <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="tvshow.clinic_id" @change="fetchClinicTv()" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                                          <option value="">Select Clinic</option>
                                          <option :value="clinic.id" v-for="clinic in clinic_lists" :key="clinic.id">{{clinic.name}}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                       
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="Boolean(clinic_tv.length) && tvshow.for==2">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in clinic_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in showTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.for==3">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="tvshow.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type"  :value="7">All Pharmacies</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="8">Multiple Pharmacies</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="9">Single Pharmacy</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.type==8 && tvshow.for==3">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Pharmacies <span class="text-danger">*</span></label>
                                       
                                       <select class="form-control"  @change="addPharmacy()" v-model="this.users" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                          <option :value="pharmacy_list.id" v-for="pharmacy_list in pharmacy_lists" :key="pharmacy_list.id"> {{ pharmacy_list.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(pharmacy, index) in pharmacies" :key="index">
                                             <p>{{ pharmacy.title }}<span @click="removePharmacy(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.type==9 && tvshow.for==3">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Pharmacy <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="tvshow.pharmacy_id" @change="fetchPharmacyTv()" v-bind:class="{ 'is-invalid': Boolean(errors.pharmacy_id) }">
                                          <option value="">Select Pharmacy</option>
                                          <option :value="pharmacy.id" v-for="pharmacy in pharmacy_lists" :key="pharmacy.id">{{pharmacy.name}}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.pharmacy_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                       
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="Boolean(pharmacy_tv.length) && tvshow.for==3">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in pharmacy_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in showTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.for==4">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="tvshow.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type"  :value="10">All Labs</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="11">Multiple Labs</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="12">Single Lab</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.type==11 && tvshow.for==4">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Labs <span class="text-danger">*</span></label>
                                       
                                       <select class="form-control"  @change="addLab()" v-model="this.users" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                               <option :value="lab_list.id" v-for="lab_list in lab_lists" :key="lab_list.id"> {{ lab_list.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(lab, index) in labs" :key="index">
                                             <p>{{ lab.title }}<span @click="removeLab(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="tvshow.type==12 && tvshow.for==4">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Lab <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="tvshow.lab_id" @change="fetchLabTv()" v-bind:class="{ 'is-invalid': Boolean(errors.lab_id) }">
                                          <option value="">Select Lab</option>
                                          <option :value="lab.id" v-for="lab in lab_lists" :key="lab.id">{{lab.name}}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.lab_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                       
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="Boolean(lab_tv.length) && tvshow.for==4">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in lab_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in showTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>


                           <b-col md="12" class="form-group" v-if="!edit">
                              <label class="control-label">Video <span class="text-danger">*</span></label>
                              <input type="file" @change="setFile($event)" accept=".mp4" class="form-control" :class="{ 'is-invalid': Boolean(errors.video) }">

                              <div v-for="(val, index) in errors.video" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <!-- <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('tvshow-modal')">Close</b-button>
                           </b-col> -->
                           <b-col md="12">
                           <div class="page-loader" v-if="!loading">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }} </b-button>
                              
                              <b-button class="" variant="light" @click="hideModal('tvshow-modal')">Close</b-button>
                           </div> 

                           <div class="page-loader" v-else>
                              <img src="@/assets/images/preloaderspin.gif"/>
                           </div>

                        </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
<style lang="scss" scoped>
   // $colors: #8CC271, #69BEEB, #F5AA39, #E9643B;
 
  .page-loader img {
   max-width: 30px;
  }
</style>
